module.exports = __webpack_public_path__ + "static/media/instagram.d512fc9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/instagram.svg
// module id = 809
// module chunks = 0